import { render, staticRenderFns } from "./TextEllipsisOld.vue?vue&type=template&id=0b071d9e&scoped=true&"
import script from "./TextEllipsisOld.vue?vue&type=script&lang=ts&"
export * from "./TextEllipsisOld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b071d9e",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
